// extracted by mini-css-extract-plugin
export default {"main-container":"styles_main-container__djtzg","go-back-button":"styles_go-back-button__QuRdH","send-request-success":"styles_send-request-success__sx9OF"};